export default "/_next/static/images/roi-squiggle1-b50ab1f08d36d0b4981974a23486574a.svg";